/**
 * Safari < 17 and iOS 16 do not implement the static `URL.canParse`. The
 * `@braintree/sanitize-url` dependency (pulled in by `stream-chat-react` when
 * rendering chat attachments) calls it unconditionally, crashing the chat into
 * the React error boundary on those browsers. This installs a spec-compatible
 * fallback when the native method is missing.
 */
export function polyfillUrlCanParse(): void {
    if (typeof URL.canParse === "function") {
        return;
    }

    URL.canParse = (url: string | URL, base?: string | URL): boolean => {
        try {
            new URL(url, base);
            return true;
        } catch {
            return false;
        }
    };
}
